document.addEventListener('DOMContentLoaded', function documentLoad() {
	const menu = document.getElementById('mobile-landing-icon');
	const landingMenu = document.getElementById('landing-menu');
	const nav = document.getElementsByClassName('landing-text');
	if (menu) {
		menu.addEventListener('click', () => {
			landingMenu.classList.toggle('active');
		});
	}

	if (nav) {
		nav.forEach(val => {
			val.addEventListener('click', function () {
				landingMenu.classList.toggle('active');
			});
		});
	}
});
